import { CardWrapper } from '@spa/scenes/Plannings/components'
import type { LabelModel } from '@spa/scenes/Plannings/redux/models/Label'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import type { TeamModel } from '@spa/scenes/Plannings/redux/models/Team'
import React from 'react'
import type { PropsWithChildren, FC } from 'react'

type Props = {
  shift: ShiftModel
  team: TeamModel
  shiftTeam: TeamModel
  label: LabelModel
  outlined?: boolean
  disabled?: boolean
}
const ShiftWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  shift,
  team,
  shiftTeam,
  label,
  outlined,
  disabled
}) => {
  const hasDifferentTeam = !team.weeklyschedules?.includes(
    shift.weeklyschedule_id
  )
  const hasDifferentLocation = shiftTeam
    ? shiftTeam.location_id !== team.location_id
    : true

  return (
    <CardWrapper
      disabled={disabled}
      outlined={outlined || !!shift.validated_at}
      hatched={hasDifferentTeam || hasDifferentLocation}
      color={label?.color}
    >
      {children}
    </CardWrapper>
  )
}

export default ShiftWrapper
